/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const title = "CLI Reference", lastUpdatedDate = new Date(1669593600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: "CLI Reference",
        description: null,
        lastUpdatedDate: "Mon Nov 28 2022 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: null,
        type: null,
        icon: null,
        toc: [{
          "depth": 0,
          "id": "ht-destinations"
        }, {
          "depth": 0,
          "id": "ht-inspect-resource"
        }, {
          "depth": 0,
          "id": "ht-login"
        }, {
          "depth": 0,
          "id": "ht-models"
        }, {
          "depth": 0,
          "id": "ht-runs"
        }, {
          "depth": 0,
          "id": "ht-sources"
        }, {
          "depth": 0,
          "id": "ht-syncs"
        }, {
          "depth": 0,
          "id": "ht-trigger-sync"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      ul: "ul",
      li: "li",
      a: "a",
      code: "code",
      h2: "h2",
      p: "p",
      pre: "pre",
      span: "span",
      em: "em"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
      children: [_jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#ht-destinations",
            children: _jsx(_components.code, {
              children: "ht destinations"
            })
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#ht-inspect-resource",
            children: _jsx(_components.code, {
              children: "ht inspect RESOURCE"
            })
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#ht-login",
            children: _jsx(_components.code, {
              children: "ht login"
            })
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#ht-models",
            children: _jsx(_components.code, {
              children: "ht models"
            })
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#ht-runs",
            children: _jsx(_components.code, {
              children: "ht runs"
            })
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#ht-sources",
            children: _jsx(_components.code, {
              children: "ht sources"
            })
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#ht-syncs",
            children: _jsx(_components.code, {
              children: "ht syncs"
            })
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "#ht-trigger-sync",
            children: _jsx(_components.code, {
              children: "ht trigger SYNC"
            })
          })
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        id: "ht-destinations",
        children: _jsx(_components.code, {
          children: "ht destinations"
        })
      }), "\n", _jsx(_components.p, {
        children: "List all destinations in current workspace"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-ruby",
          children: [_jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "USAGE"
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-variable",
            children: "$ "
          }), "ht destinations\n\n", _jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "DESCRIPTION"
          }), "\n  List all destinations ", _jsx(_components.span, {
            className: "hljs-keyword",
            children: "in"
          }), " current workspace\n\n", _jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "ALIASES"
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-variable",
            children: "$ "
          }), "ht destination\n\n", _jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "EXAMPLES"
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-variable",
            children: "$ "
          }), "ht destinations\n"]
        })
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["See code: ", _jsx(_components.a, {
            href: "https://github.com/hightouchio/cli/blob/v0.1.0/src/commands/destinations.ts",
            children: "src/commands/destinations.ts"
          })]
        })
      }), "\n", _jsx(_components.h2, {
        id: "ht-inspect-resource",
        children: _jsx(_components.code, {
          children: "ht inspect RESOURCE"
        })
      }), "\n", _jsx(_components.p, {
        children: "Inspect resources in the current workspace"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-scss",
          children: ["USAGE\n  $ ht inspect ", _jsx(_components.span, {
            className: "hljs-selector-attr",
            children: "[RESOURCE]"
          }), " -f <value>\n\nARGUMENTS\n  RESOURCE  Resource ID\n\nFLAGS\n  -f, ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "--format"
          }), "=<value>  (required) ", _jsx(_components.span, {
            className: "hljs-selector-attr",
            children: "[default: json]"
          }), " Output ", _jsx(_components.span, {
            className: "hljs-built_in",
            children: "format"
          }), "(yaml/json)\n\nDESCRIPTION\n  Inspect resources in the current workspace\n\nEXAMPLES\n  $ ht inspect model/run-user\n"]
        })
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["See code: ", _jsx(_components.a, {
            href: "https://github.com/hightouchio/cli/blob/v0.1.0/src/commands/inspect.ts",
            children: "src/commands/inspect.ts"
          })]
        })
      }), "\n", _jsx(_components.h2, {
        id: "ht-login",
        children: _jsx(_components.code, {
          children: "ht login"
        })
      }), "\n", _jsx(_components.p, {
        children: "Login Hightouch with API key"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-ruby",
          children: [_jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "USAGE"
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-variable",
            children: "$ "
          }), "ht login\n\n", _jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "DESCRIPTION"
          }), "\n  Login Hightouch with ", _jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "API"
          }), " key\n\n", _jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "EXAMPLES"
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-variable",
            children: "$ "
          }), "ht login\n"]
        })
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["See code: ", _jsx(_components.a, {
            href: "https://github.com/hightouchio/cli/blob/v0.1.0/src/commands/login.ts",
            children: "src/commands/login.ts"
          })]
        })
      }), "\n", _jsx(_components.h2, {
        id: "ht-models",
        children: _jsx(_components.code, {
          children: "ht models"
        })
      }), "\n", _jsx(_components.p, {
        children: "List all models in current workspace"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-ruby",
          children: [_jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "USAGE"
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-variable",
            children: "$ "
          }), "ht models\n\n", _jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "DESCRIPTION"
          }), "\n  List all models ", _jsx(_components.span, {
            className: "hljs-keyword",
            children: "in"
          }), " current workspace\n\n", _jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "ALIASES"
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-variable",
            children: "$ "
          }), "ht model\n\n", _jsx(_components.span, {
            className: "hljs-variable constant_",
            children: "EXAMPLES"
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-variable",
            children: "$ "
          }), "ht models\n"]
        })
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["See code: ", _jsx(_components.a, {
            href: "https://github.com/hightouchio/cli/blob/v0.1.0/src/commands/models.ts",
            children: "src/commands/models.ts"
          })]
        })
      }), "\n", _jsx(_components.h2, {
        id: "ht-runs",
        children: _jsx(_components.code, {
          children: "ht runs"
        })
      }), "\n", _jsx(_components.p, {
        children: "List all syncs run for a given sync"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-css",
          children: ["USAGE\n  $ ht runs -s <value> ", _jsx(_components.span, {
            className: "hljs-selector-attr",
            children: "[-l <value>]"
          }), "\n\nFLAGS\n  -l, ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "--limit"
          }), "=<value>  ", _jsx(_components.span, {
            className: "hljs-selector-attr",
            children: "[default: 5]"
          }), " Limit the number of runs ", _jsx(_components.span, {
            className: "hljs-selector-tag",
            children: "to"
          }), " output\n  -s, ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "--sync"
          }), "=<value>   (required) Specify sync name ", _jsx(_components.span, {
            className: "hljs-selector-tag",
            children: "to"
          }), " list runs\n\nDESCRIPTION\n  List ", _jsx(_components.span, {
            className: "hljs-attribute",
            children: "all"
          }), " syncs run for ", _jsx(_components.span, {
            className: "hljs-selector-tag",
            children: "a"
          }), " given sync\n\nALIASES\n  $ ht run\n\nEXAMPLES\n  $ ht runs\n"]
        })
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["See code: ", _jsx(_components.a, {
            href: "https://github.com/hightouchio/cli/blob/v0.1.0/src/commands/runs.ts",
            children: "src/commands/runs.ts"
          })]
        })
      }), "\n", _jsx(_components.h2, {
        id: "ht-sources",
        children: _jsx(_components.code, {
          children: "ht sources"
        })
      }), "\n", _jsx(_components.p, {
        children: "List all sources in current workspace"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-shell",
          children: ["USAGE\n", _jsx(_components.span, {
            className: "hljs-meta prompt_",
            children: "  $ "
          }), _jsx(_components.span, {
            className: "bash",
            children: "ht sources"
          }), "\n\nDESCRIPTION\n  List all sources in current workspace\n\nALIASES\n", _jsx(_components.span, {
            className: "hljs-meta prompt_",
            children: "  $ "
          }), _jsxs(_components.span, {
            className: "bash",
            children: ["ht ", _jsx(_components.span, {
              className: "hljs-built_in",
              children: "source"
            })]
          }), "\n\nEXAMPLES\n", _jsx(_components.span, {
            className: "hljs-meta prompt_",
            children: "  $ "
          }), _jsx(_components.span, {
            className: "bash",
            children: "ht sources"
          }), "\n"]
        })
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["See code: ", _jsx(_components.a, {
            href: "https://github.com/hightouchio/cli/blob/v0.1.0/src/commands/sources.ts",
            children: "src/commands/sources.ts"
          })]
        })
      }), "\n", _jsx(_components.h2, {
        id: "ht-syncs",
        children: _jsx(_components.code, {
          children: "ht syncs"
        })
      }), "\n", _jsx(_components.p, {
        children: "List all syncs in current workspace"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-shell",
          children: ["USAGE\n", _jsx(_components.span, {
            className: "hljs-meta prompt_",
            children: "  $ "
          }), _jsx(_components.span, {
            className: "bash",
            children: "ht syncs"
          }), "\n\nDESCRIPTION\n  List all syncs in current workspace\n\nALIASES\n", _jsx(_components.span, {
            className: "hljs-meta prompt_",
            children: "  $ "
          }), _jsxs(_components.span, {
            className: "bash",
            children: ["ht ", _jsx(_components.span, {
              className: "hljs-built_in",
              children: "sync"
            })]
          }), "\n\nEXAMPLES\n", _jsx(_components.span, {
            className: "hljs-meta prompt_",
            children: "  $ "
          }), _jsx(_components.span, {
            className: "bash",
            children: "ht syncs"
          }), "\n"]
        })
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["See code: ", _jsx(_components.a, {
            href: "https://github.com/hightouchio/cli/blob/v0.1.0/src/commands/syncs.ts",
            children: "src/commands/syncs.ts"
          })]
        })
      }), "\n", _jsx(_components.h2, {
        id: "ht-trigger-sync",
        children: _jsx(_components.code, {
          children: "ht trigger SYNC"
        })
      }), "\n", _jsx(_components.p, {
        children: "Trigger sync to run"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-css",
          children: ["USAGE\n  $ ht trigger ", _jsx(_components.span, {
            className: "hljs-selector-attr",
            children: "[SYNC]"
          }), " ", _jsx(_components.span, {
            className: "hljs-selector-attr",
            children: "[-f]"
          }), " ", _jsx(_components.span, {
            className: "hljs-selector-attr",
            children: "[-q]"
          }), "\n\nARGUMENTS\n  SYNC  Sync ID\n\nFLAGS\n  -f, ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "--full-sync"
          }), "  Whether ", _jsx(_components.span, {
            className: "hljs-selector-tag",
            children: "to"
          }), " run ", _jsx(_components.span, {
            className: "hljs-selector-tag",
            children: "a"
          }), " full sync\n  -", _jsx(_components.span, {
            className: "hljs-selector-tag",
            children: "q"
          }), ", ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "--quiet"
          }), "      Whether ", _jsx(_components.span, {
            className: "hljs-selector-tag",
            children: "to"
          }), " show run progress\n\nDESCRIPTION\n  Trigger sync ", _jsx(_components.span, {
            className: "hljs-selector-tag",
            children: "to"
          }), " run\n\nEXAMPLES\n  $ ht trigger ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "--sync"
          }), " test123\n"]
        })
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["See code: ", _jsx(_components.a, {
            href: "https://github.com/hightouchio/cli/blob/v0.1.0/src/commands/trigger.ts",
            children: "src/commands/trigger.ts"
          })]
        })
      })]
    });
  }
}
export default MDXContent;
